import type { TrackedOrder } from '@xshop/shared';
import { placeholderProducts } from './placeholderCatalog';

// The order the builder and a theme preview show under the lookup, so a merchant styles the page with the
// card a shopper will see: two lines on their way, with a tracking number.

// Builds the sample order from the theme's own stand-in products.
export function sampleTrackedOrder(): TrackedOrder {
  const lines = placeholderProducts(2).map((product, index) => ({
    title: product.title, variantTitle: null, quantity: index + 1, imageUrl: product.images[0]?.src ?? null,
    totalPrice: Number(product.variants[0]?.price ?? 0) * (index + 1)
  }));
  const subtotal = lines.reduce((sum, line) => sum + line.totalPrice, 0);
  return {
    orderNumber: '#1001', placedAt: new Date().toISOString(), stage: 'shipped', city: 'Casablanca', currency: 'MAD',
    subtotal, shipping: 0, discount: 0, total: subtotal, items: lines,
    tracking: { company: 'Carrier', number: 'TRK000123', url: null }
  };
}
